import axiosInstance from '../../app/apiClient'
import { AuthAdminService } from '../model/authAdmin.model'

const loginCMS = (username: string, password: string) =>
    axiosInstance.post('api/v1/auth/login-cms', {
        username: username,
        password: password,
    })

const register = (data: string) =>
    axiosInstance.post('api/v1/auth/register', data)

const authAdminService: AuthAdminService= {
    loginCMS,
    register,
}

export default authAdminService
